import axios from 'axios'
import merge from 'deepmerge'
var config = SYSCONFIG

export default {
    install(Vue) {
        Vue.prototype.send = function (_option) {
            if(_option.server == 'ai'){
                var _url = config.errorLog.server.ai.url + _option.url
            }
            if(_option.server == 'wm'){
                var _url = config.errorLog.server.wm.url + _option.url
            }
            var version=""
            var _default = {
                url: _url,
                method: "post",
                confirm: false,
                loading: true,
                params: config.defaultData,
                data: config.defaultData,
                success: function (res) {
                    return true
                },
            }
            send()
            function send() {
                axios({
                    method: _default.method,
                    url: _default.url,
                    data: Object.assign(config.defaultData,_option.data),
                    params: _default.params,
                }).then(function (response) {
                    if(_option.loading==true){
                        loading.clear()
                    }
                    _option.success(response.data)
                }).catch(function (error) {

                });
            }

        }
    }
}
